<footer class="footer-section ptb-100" >
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <div class="footer-heading">
                        <h3>About Us</h3>
                    </div>
                    <p [innerHTML]="setup?.subTitle" > </p>
<!--                    <ul class="footer-social">-->
<!--                        <li><a href="#" target="_blank"><i class="fab fa-facebook-f"></i></a></li>-->
<!--                        <li><a href="#" target="_blank"><i class="fab fa-twitter"></i></a></li>-->
<!--                        <li><a href="#" target="_blank"><i class="fab fa-pinterest"></i></a></li>-->
<!--                        <li><a href="#" target="_blank"><i class="fab fa-linkedin"></i></a></li>-->
<!--                    </ul>-->
                </div>
            </div>
            <div class="col-lg-2 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <div class="footer-heading">
                        <h3>Important Links</h3>
                    </div>
                    <ul class="footer-quick-links">
                        <li><a routerLink="/about">About Us</a></li>
                        <li><a routerLink="/projects">Project</a></li>
                        <li><a routerLink="/services">Services</a></li>
                        <li><a routerLink="/team">Team</a></li>
                        <li><a routerLink="/contact">Contact</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-2 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <div class="footer-heading">
                        <h3>Featured Service</h3>
                    </div>
                    <ul class="footer-quick-links">
                        <li><a routerLink="/projects">Project</a></li>
                        <li><a routerLink="/services">Services</a></li>
                        <li><a routerLink="/team">Team</a></li>
                        <li><a routerLink="/contact">Contact</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <div class="footer-heading">
                        <h3>Contact</h3>
                    </div>
                    <div class="footer-info-contact">
                        <i class="flaticon-call-answer"></i>
                        <h3>Phone</h3>
                        <span><a href="tel:{{setup.phone}}">{{setup.phone}}</a></span>
                    </div>
                    <div class="footer-info-contact">
                        <i class="flaticon-envelope"></i>
                        <h3>Email</h3>
                        <span><a href="mailto:{{setup.email}}">{{setup.email}}</a></span>
                    </div>
                    <div class="footer-info-contact">
                        <i class="flaticon-maps-and-flags"></i>
                        <h3>Address</h3>
                        <span>{{setup.address}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="lines">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
    </div>
    <div class="partner-shape-img1">
        <img src="assets/img/shape/partnar-shape-2.png" alt="image">
    </div>
</footer>

<div class="copyright-area">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-6">
                <p>© Value Engineering is Developed by <a href="https://wa.link/43ttrh" target="_blank">Eng Hossam Mahmoud</a></p>
            </div>
            <div class="col-lg-6 col-md-6">
                <ul>
<!--                    <li><a routerLink="/terms-conditions">Terms & Conditions</a></li>-->
<!--                    <li><a routerLink="/privacy-policy">Privacy Policy</a></li>-->
                </ul>
            </div>
        </div>
    </div>
</div>

<div class="go-top">
    <i class="fas fa-chevron-up"></i>
    <i class="fas fa-chevron-up"></i>
</div>
